import { cid } from './env.mjs';

/**
 * @module @mkt-common/shopee-common
 */
/*
Some note about naming convention: The suffix "ALL" means
it contains mappings to ALL the countries, a holistic map of view
to all the URLs available (across different countries and regions).

we could have named each of them XXX_MAP, but naming
with data structure is often discouraged.
 */
const FILE_CDN_PREFIX_ALL = {
    sg: 'https://cf.shopee.sg/file/',
    my: 'https://cf.shopee.com.my/file/',
    ph: 'https://cf.shopee.ph/file/',
    tw: 'https://cf.shopee.tw/file/',
    vn: 'https://cf.shopee.vn/file/',
    th: 'https://cf.shopee.co.th/file/',
    id: 'https://cf.shopee.co.id/file/',
    br: 'https://cf.shopee.com.br/file/',
    mx: 'https://cf.shopee.com.mx/file/',
    co: 'https://cf.shopee.com.co/file/',
    cl: 'https://cf.shopee.cl/file/',
    xx: 'https://cf.shopee.sg/file/',
};
function cdnFile(hash, region = cid) {
    if (!hash) {
        return '';
    }
    // 防止有些是encode之后的值，https%3A%2F%2Fcf.shopee.co.id%2Ffile%2Fc07a6c240922ee290b0100241a724339
    const decodeHash = decodeURIComponent(hash);
    if (/^https?\:\/\/cf\.shopee/.test(decodeHash)) {
        return decodeHash;
    }
    return `${FILE_CDN_PREFIX_ALL[region]}${hash}`;
}
function cdnAudioFruitNinja(hash) {
    const FRUIT_NINJA_AUDIO_PREFIX_ALL = 'https://deo.shopeemobile.com/shopee/mkt/fruitninja/audio/';
    if (!hash) {
        return '';
    }
    return `${FRUIT_NINJA_AUDIO_PREFIX_ALL}${hash}`;
}
function cdnAudioRainingCoins(hash) {
    const RAINING_COINS_AUDIO_PREFIX_ALL = 'https://deo.shopeemobile.com/shopee/mkt/gameabr/audio/';
    if (!hash) {
        return '';
    }
    return `${RAINING_COINS_AUDIO_PREFIX_ALL}${hash}`;
}
/*
All common pictures used in games, specific information is here: https://docs.google.com/document/d/19MWESXFfgVhg74MiB9I_siz_bIygkmSVxwXQmXMI77U/edit.
 */
const CdnCommonImage = {
    NETWORK_ERROR: '2a27d99e2b2beaa71bb62b6de0befb4a',
    NOT_AVAILABLE: '3d25f7768d016a1c433e99a716fb32f6',
    ERROR_404: '86cdd812207a0fb4bb1c5621a4e3043d',
    SPIN_TO_MUCH: '4d832a0ea90614b943f76cd42fb433c4',
    NEGATIVE_TIPS: '86f92ea23d26763a5f80af2631fc2485',
    HAND: '61dbcd15c5fc768faeba3d36c767044f',
    CLOSE: 'b8e8cb473a990699a870231671b168b5',
    PC_CLOSE: '7ebbb9a9de4962e3dd8d56b3b275cbc0',
    FACEBOOK: 'e776213a26c5f0f4af0c0f4f1b49d8c9',
    GOOGLE_PLUS: '5f2df75b32beb6539c7351c55c9958f6',
    MESSENGER: '0dc5502519275145d518600eb98b9b3a',
    PINTEREST: '13834965b830eb30c4a51938d102ce9b',
    TWITTER: '7208fb28f1fd1f6cc92b22695f70fcca',
    AVATAR: 'f45ba2e1b54507a6fbf845ae6a14f516',
    LIGHT: 'e4135b1229c87f97ee4b1661e9048896',
    ONLY_MOBILE: '3b2b39b6254bccc82c4a3d5783521a8a',
    ONLY_APP: '5052a3530bc50a2f31ada9dfa676a1ae',
    INSTAGRAM: '68b48efdae0826e76a34229e2069cc9e',
    LINE: '9fbbe75ba431b00d82bfde58ae5cba39',
    WHATSAPP: 'd975daaad414cf691e9ad26e196ee6dc',
    TELEGRAM: 'b6ac268f3ee6f6c249ba764932c0759d',
    VIBER: '8f4a0b15ca70b75b86587650d5adcdd1',
    ZALO: 'a5e5c9691fac5439fd8331636097ea07',
    SMS: '426a9b32b2a5b5c9abd12b1c51034682',
    COPYINFO: 'a9a5c098f5aed0eab1f68f0f5c169d55',
    COPYLINK: '3af9a49433b0de540e56baa7b24d8dcb',
    EMAIL: 'e0cf0e116021fa4ede36332953923ba8',
    FIRST: 'a64631f658b3f4ecd3a70e714cf4d358',
    SECOND: 'ae0cfcc95e616f78a8691f232043c076',
    THREE: '3f0cd055c910f822f48971593537a1b3',
};

export { CdnCommonImage, FILE_CDN_PREFIX_ALL, cdnAudioFruitNinja, cdnAudioRainingCoins, cdnFile };
